import FormattedDate from "../FormattedDate";
import {
  CalendarIcon,
  CommentIcon,
  HeartIcon,
  ObservationIcon,
  PhotoIcon,
} from "../Icon";
import cls from "./styles.module.css";
import cn from "clsx";

type TProps = {
  likesCount?: number;
  commentsCount?: number;
  observationsCount?: number;
  photosCount?: number;
  date?: string;
  className?: string;
};
export default function PostMetadata({
  className,
  likesCount = 0,
  commentsCount = 0,
  observationsCount = 0,
  photosCount = 0,
  date,
}: TProps) {
  return (
    <div className={cn(cls.root, className)}>
      <div className={cls.item}>
        <HeartIcon title="Лайки" color="var(--heart-color)" />
        <span>{likesCount}</span>
      </div>
      {observationsCount > 0 && (
        <div className={cls.item}>
          <ObservationIcon title="Наблюдения" />
          <span>{observationsCount}</span>
        </div>
      )}
      {photosCount > 0 && (
        <div className={cls.item}>
          <PhotoIcon title="Фотографии" />
          <span>{photosCount}</span>
        </div>
      )}
      {commentsCount > 0 && (
        <div className={cls.item}>
          <CommentIcon title="Комментарии" />
          <span>{commentsCount}</span>
        </div>
      )}
      {date && (
        <div className={cls.item}>
          <CalendarIcon aria-hidden />
          <FormattedDate date={date} isSSR />
        </div>
      )}
    </div>
  );
}
